angular.module('components.authoring.header', [
])

/**
 * The componentHeader provides a preview
 * of the header item type
 *
 * @class componentHeader
 * @constructor
 * @module components.authoring.header
 * @example
 *   <component-header>
 *   </component-header>
 */
.directive('componentHeader', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        return 'components/authoring/header/header.html';
      }
    };
  }
]);
